import { styled } from '@mui/material/styles';

export const Spinner = styled('div')(({ theme }) => ({
	margin: theme.spacing(6, 'auto'),
	position: 'relative',
}));
